const messageTitle = Object.freeze({
  PendingInformation: 'Solicitud Pendiente de Información',
  Resolved: 'Resuelto',
});

export default messageTitle;
